import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import Admin from "./Admin.jsx";
import { LangProvider } from "./i18n.jsx";
import "./index.css";

const isAdmin = window.location.pathname.replace(/\/+$/, "") === "/admin";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <LangProvider>{isAdmin ? <Admin /> : <App />}</LangProvider>
  </React.StrictMode>
);
